module.exports = __webpack_public_path__ + "img/women-cooperative-filled.f8b5fe55.svg";